import { ActionReducerMap, MetaReducer } from "@ngrx/store";

import { IAppState } from "../states/app";
import { BootReducers } from "../reducers/boot";
import { UserReducers } from "../reducers/user";
import { SettingsReducers } from "../reducers/settings";
import { TimerReducers } from "../reducers/timer";
import { AdminReducers } from "../reducers/admin.reducer";
import { ConnectionReducers } from "./connection";
import { TermsAndConditionsReducers } from "./termsAndConditions";
import { SharedReducer } from "./shared.reducer";
export const reducers: ActionReducerMap<IAppState, any> = {
  booted: BootReducers,
  user: UserReducers,
  settings: SettingsReducers,
  timer: TimerReducers,
  connection: ConnectionReducers,
  admin: AdminReducers,
  termsAndConditions: TermsAndConditionsReducers,
  shared: SharedReducer,
};

export const metaReducers: MetaReducer<IAppState>[] =
  process.env.PRODUCTION === "true" ? [] : [];
